module.exports = require('./lib/jwt');



//////////////////
// WEBPACK FOOTER
// ./~/jwt-simple/index.js
// module id = Adj7
// module chunks = 0